import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import moment from "../../common/UserMoment";

import "./index.css";

const Footer = () => {
  const isStaging = process.env.REACT_APP_ENV === "STAGE";
  const locationLabel = process.env.REACT_APP_LOCATION_LABEL;
  
  return (
    <footer className="footer Site-footer">
      <Container>
        <Row>
          <Col sm="12">
            {/* Copyright &copy; yMantra 2021 */}
            Copyright &copy; ptMantra{isStaging && locationLabel ? ` [${locationLabel}]` : ""} {moment().format("Y")}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
